export default __webpack_public_path__ + "static/media/kaitlyn.928419e1.png";